// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import {
  InvoiceLineItemFilter,
  getInvoiceLineItems,
  serializeInvoiceLineItemFilter,
} from '@/billing/api/get-invoice-line-items';
import { TWO_MINUTES_MS } from '@/utilities/time-constants';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

interface UseInvoiceLineItemsOptions {
  filter?: InvoiceLineItemFilter;
}

export function useInvoiceLineItems(options: UseInvoiceLineItemsOptions = {}) {
  const filter = options.filter ?? { pageSize: 20 };
  const serializedFilter = serializeInvoiceLineItemFilter(filter);

  const { data, isLoading, isFetching, isPlaceholderData } = useQuery({
    queryKey: ['invoice-line-items', 'list', serializedFilter],
    queryFn: () => getInvoiceLineItems(filter),
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: true,
    refetchInterval: TWO_MINUTES_MS,
  });

  return {
    lineItems: data?.results ?? null,
    totalCount: data?.totalCount ?? null,
    summary: data?.summary ?? null,
    isLoading,
    isFetching,
    isPlaceholderData,
  };
}
